/**
 * WelcomeStep — step 1 of the onboarding wizard.
 * Shows a hero graphic, headline, org name, and overview of what to expect.
 */

interface WelcomeStepProps {
  orgId: string;
}

export function WelcomeStep({ orgId }: WelcomeStepProps) {
  const steps = ['Set up your profile', 'Choose your interests', 'Take a quick tour'];

  return (
    <div className="flex flex-col items-center px-6 py-10 text-center">
      {/* Hero graphic */}
      <div
        className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-5xl shadow-lg"
        aria-hidden="true"
      >
        👋
      </div>

      <h2 className="mb-1 text-2xl font-bold text-gray-900 lg:text-3xl">Welcome to Martha</h2>

      <p className="mb-6 text-sm font-medium text-gray-400">
        Organisation: <span className="font-semibold text-gray-600">{orgId}</span>
      </p>

      <p className="mb-8 max-w-md text-base leading-relaxed text-gray-600">
        Let's get you set up in a few minutes. We'll personalise Martha to match your role and
        interests.
      </p>

      <div className="flex flex-wrap justify-center gap-4">
        {steps.map((label, i) => (
          <div key={i} className="flex items-center gap-2 text-sm text-gray-600">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-700">
              {i + 1}
            </span>
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
